import _regeneratorRuntime from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/travis/build/gladly-team/tab/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import subtleAlgorithm from './subtle_rsaes.js';
import bogusWebCrypto from './bogus.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import { checkEncCryptoKey } from '../lib/crypto_key.js';
import checkKeyLength from './check_key_length.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { types } from './is_key_like.js';
export var encrypt =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(alg, key, cek) {
    var _crypto$subtle, cryptoKeyCek;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (isCryptoKey(key)) {
              _context.next = 2;
              break;
            }

            throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));

          case 2:
            checkEncCryptoKey(key, alg, 'encrypt', 'wrapKey');
            checkKeyLength(alg, key);

            if (!key.usages.includes('encrypt')) {
              _context.next = 10;
              break;
            }

            _context.t0 = Uint8Array;
            _context.next = 8;
            return crypto.subtle.encrypt(subtleAlgorithm(alg), key, cek);

          case 8:
            _context.t1 = _context.sent;
            return _context.abrupt("return", new _context.t0(_context.t1));

          case 10:
            if (!key.usages.includes('wrapKey')) {
              _context.next = 19;
              break;
            }

            _context.next = 13;
            return (_crypto$subtle = crypto.subtle).importKey.apply(_crypto$subtle, ['raw', cek].concat(_toConsumableArray(bogusWebCrypto)));

          case 13:
            cryptoKeyCek = _context.sent;
            _context.t2 = Uint8Array;
            _context.next = 17;
            return crypto.subtle.wrapKey('raw', cryptoKeyCek, key, subtleAlgorithm(alg));

          case 17:
            _context.t3 = _context.sent;
            return _context.abrupt("return", new _context.t2(_context.t3));

          case 19:
            throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function encrypt(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var decrypt =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(alg, key, encryptedKey) {
    var _crypto$subtle2, cryptoKeyCek;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (isCryptoKey(key)) {
              _context2.next = 2;
              break;
            }

            throw new TypeError(invalidKeyInput.apply(void 0, [key].concat(_toConsumableArray(types))));

          case 2:
            checkEncCryptoKey(key, alg, 'decrypt', 'unwrapKey');
            checkKeyLength(alg, key);

            if (!key.usages.includes('decrypt')) {
              _context2.next = 10;
              break;
            }

            _context2.t0 = Uint8Array;
            _context2.next = 8;
            return crypto.subtle.decrypt(subtleAlgorithm(alg), key, encryptedKey);

          case 8:
            _context2.t1 = _context2.sent;
            return _context2.abrupt("return", new _context2.t0(_context2.t1));

          case 10:
            if (!key.usages.includes('unwrapKey')) {
              _context2.next = 19;
              break;
            }

            _context2.next = 13;
            return (_crypto$subtle2 = crypto.subtle).unwrapKey.apply(_crypto$subtle2, ['raw', encryptedKey, key, subtleAlgorithm(alg)].concat(_toConsumableArray(bogusWebCrypto)));

          case 13:
            cryptoKeyCek = _context2.sent;
            _context2.t2 = Uint8Array;
            _context2.next = 17;
            return crypto.subtle.exportKey('raw', cryptoKeyCek);

          case 17:
            _context2.t3 = _context2.sent;
            return _context2.abrupt("return", new _context2.t2(_context2.t3));

          case 19:
            throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');

          case 20:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function decrypt(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();